import { createGtm } from '@gtm-support/vue-gtm';
import vueformConfig from '@root/vueform.config';
import * as Sentry from '@sentry/vue';
import Vueform from '@vueform/vueform';
import { Axios } from 'axios';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { createApp } from 'vue';

import '@/assets/styles/scss/index.scss';
import { i18n } from '@/assets/translations';

import App from '@/App.vue';
import { router } from '@/router';

const app = createApp(App);

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

app.config.globalProperties.$axios = Axios;

// TODO: Add hosts to tracePropagationTargets
Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENV,
  integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
  tracesSampleRate: parseFloat(import.meta.env.VITE_SENTRY_TRACES_SAMPLE),
  tracePropagationTargets: ['localhost'],
  replaysSessionSampleRate: import.meta.env.VITE_SENTRY_REPLAYS_SESSION_SAMPLE,
  replaysOnErrorSampleRate: import.meta.env.VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE
});

app.use(pinia);
app.use(router);
app.use(i18n);
app.use(Vueform, vueformConfig);

if (import.meta.env.VITE_GOOGLE_TAG_MANAGER_ID) {
  app.use(
    createGtm({
      id: import.meta.env.VITE_GOOGLE_TAG_MANAGER_ID,
      enabled: true,
      debug: import.meta.env.VITE_GOOGLE_TAG_MANAGER_DEBUG_MODE, // => Dev only
      vueRouter: router
    })
  );
}

app.mount('#app');
